// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlatformSectionOne {
  background: #fff;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 18px;
  color: #1C2640;
  padding-top: 120px;
}
.PlatformSectionOne .PlatformSectionOne-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 45px;
}
.PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-header-1 {
  margin-bottom: 0;
  font-size: 35px;
  font-weight: 400;
}
.PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-header-2 {
  margin-top: 0;
  font-size: 43px;
  font-weight: 600;
}
.PlatformSectionOne .PlatformSectionOne-header .PlatformSectionOne-sub-header {
  margin-bottom: 0;
  font-size: 16.5px;
  text-align: center;
  font-weight: 400;
}
.PlatformSectionOne .PlatformSectionOne-content {
  margin-top: 3%;
  display: flex;
  align-items: center;
}
.PlatformSectionOne .PlatformSectionOne-content .image {
  width: 90%;
  padding: 25px;
  border-radius: 8px;
}
.PlatformSectionOne .PlatformSectionOne-content .para {
  padding: 10px 60px;
  font-size: 25px;
  color: #1C2640;
  font-weight: 600;
  background-color: #F2F2F2;
  border-radius: 5px;
}
.PlatformSectionOne .PlatformSectionOne-content .para-top {
  padding: 30px 60px 10px 60px;
  font-size: 25px;
  color: #1C2640;
  font-weight: 600;
  border-radius: 5px;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content,
.PlatformSectionOne .PlatformSectionOne-content .right-content {
  width: 50%;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content {
  height: 55vh;
  display: flex;
  padding-left: 250px;
  justify-items: center;
  justify-content: center;
  align-items: center;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content .diverse-data {
  width: 50%;
  text-align: center;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content .diverse-data .header-diverse {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 18.77px;
  color: #27AE60;
  margin-right: 70px;
  margin-top: 55px;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content .diverse-data img {
  margin-top: 80px;
  width: 100%;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content .planning-data {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content .planning-data .header-planning {
  font-family: Roboto;
  font-size: 16px;
  line-height: 18.77px;
  text-align: center;
  margin-top: 70px;
  margin-left: 50px;
}
.PlatformSectionOne .PlatformSectionOne-content .left-content .planning-data img {
  width: 115%;
  float: right;
}
.PlatformSectionOne .PlatformSectionOne-content .right-content {
  width: 50%;
  padding: 120px 0px 80px 0px;
  box-shadow: -10px 5px 8px 0px rgba(196, 196, 196, 0.4);
}
.PlatformSectionOne .PlatformSectionOne-content .right-content .card-content {
  height: 144px;
  padding: 10px 50px;
}
.PlatformSectionOne .PlatformSectionOne-content .right-content .card-content .header {
  font-family: Roboto;
  font-size: 32px;
  font-weight: 700;
  line-height: 37.5px;
  text-align: left;
  color: #fff;
  margin-bottom: 10px;
}
.PlatformSectionOne .PlatformSectionOne-content .right-content .card-content .description {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  line-height: 19.05px;
  text-align: left;
  color: #fff;
  width: 40%;
}
.PlatformSectionOne .PlatformSectionOne-content .right-content .orange {
  background: #EC6927;
}
.PlatformSectionOne .PlatformSectionOne-content .right-content .yellow {
  background: #E7B051;
}
.PlatformSectionOne .PlatformSectionOne-content .right-content .purple {
  background: #9DAAF1;
}
.PlatformSectionOne .PlatformSectionOne-card {
  padding: 0 30px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  z-index: 1;
  margin-top: 60px;
}
.PlatformSectionOne .PlatformSectionOne-card .box-card {
  padding: 30px;
  width: 230px;
  height: 252px;
  margin-right: 25px;
  background: #FFFFFF;
  box-shadow: 0px 4px 5px #C4C4C4;
  border-radius: 3px;
  border-top: 7px #EC6927 solid;
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease 0s;
}
.PlatformSectionOne .PlatformSectionOne-card .box-card .card-description {
  margin-top: 20px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
}
.PlatformSectionOne .PlatformSectionOne-card .box-card:hover {
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/Platform/SectionOne/SectionOne.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,WAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAAD;AACC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AACF;AAAE;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;AAEH;AAAE;EACC,aAAA;EACA,eAAA;EACA,gBAAA;AAEH;AAAE;EACC,gBAAA;EACG,iBAAA;EACA,kBAAA;EACA,gBAAA;AAEN;AAEC;EACC,cAAA;EACA,aAAA;EACA,mBAAA;AAAF;AACE;EACC,UAAA;EAEG,aAAA;EACA,kBAAA;AAAN;AAEK;EACC,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAAN;AAEE;EACC,4BAAA;EACA,eAAA;EACG,cAAA;EACA,gBAAA;EAEA,kBAAA;AADN;AAGK;;EAEC,UAAA;AADN;AAGK;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAEG;EACC,UAAA;EACA,kBAAA;AAAJ;AACI;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACL;AACI;EACC,gBAAA;EACA,WAAA;AACL;AAEG;EACC,UAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AACI;EACC,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACL;AAEI;EACC,WAAA;EACA,YAAA;AAAL;AAOK;EACC,UAAA;EACA,2BAAA;EACA,sDAAA;AALN;AAMM;EACC,aAAA;EACA,kBAAA;AAJP;AAMO;EACC,mBAAA;EACH,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAJL;AAMO;EACC,mBAAA;EACH,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AAJL;AAOM;EACC,mBAAA;AALP;AAOM;EACC,mBAAA;AALP;AAOM;EACC,mBAAA;AALP;AAUC;EACC,eAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AARF;AASE;EACC,aAAA;EACA,YAAA;EACG,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,4BAAA;AAPN;AAQM;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AANP;AASE;EACC,sBAAA;AAPH","sourcesContent":[".PlatformSectionOne {\n\tbackground: #fff;\n\twidth: 100%;\n\t// height: 750px;\n\theight: auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tfont-size: 18px;\n\tcolor: #1C2640;\n\tpadding-top: 120px;\n\t.PlatformSectionOne-header {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tpadding-top: 45px;\n\t\t.PlatformSectionOne-header-1 {\n\t\t\tmargin-bottom: 0;\n\t\t\tfont-size: 35px;\n\t\t\tfont-weight: 400;\n\t\t}\n\t\t.PlatformSectionOne-header-2 {\n\t\t\tmargin-top: 0;\n\t\t\tfont-size: 43px;\n\t\t\tfont-weight: 600;\n\t\t}\n\t\t.PlatformSectionOne-sub-header {\n\t\t\tmargin-bottom: 0;\n\t\t    font-size: 16.5px;\n\t\t    text-align: center;\n\t\t    font-weight: 400;\n\t\t}\n\t}\n\n\t.PlatformSectionOne-content {\n\t\tmargin-top: 3%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t.image {\n\t\t\twidth: 90%;\n\t    \t// background-color: white;\n\t\t    padding: 25px;\n\t\t    border-radius: 8px;\n\t    }\n\t    .para {\n\t    \tpadding: 10px 60px;\n\t    \tfont-size: 25px;\n\t    \tcolor: #1C2640;\n\t    \tfont-weight: 600;\n\t    \tbackground-color: #F2F2F2;\n\t    \tborder-radius: 5px;\n\t    }\n\t\t.para-top {\n\t\t\tpadding: 30px 60px 10px 60px;\n\t\t\tfont-size: 25px;\n\t    \tcolor: #1C2640;\n\t    \tfont-weight: 600;\n\t    \t// background-color: #F2F2F2;\n\t    \tborder-radius: 5px;\n\t    }\n\t    .left-content,\n\t    .right-content{\n\t    \twidth: 50%;\n\t    }\n\t    .left-content{\n\t    \theight: 55vh;\n\t    \tdisplay: flex;\n\t    \tpadding-left: 250px; \n\t    \tjustify-items: center;\n    \t\tjustify-content: center;\n    \t\talign-items: center;\n\t\t\t.diverse-data{\n\t\t\t\twidth: 50%;\n\t\t\t\ttext-align: center;\n\t\t\t\t.header-diverse{\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tline-height: 18.77px;\n\t\t\t\t\tcolor: #27AE60;\n\t\t\t\t\tmargin-right: 70px;\n\t\t\t\t\tmargin-top: 55px;\n\t\t\t\t}\n\t\t\t\timg{\n\t\t\t\t\tmargin-top: 80px;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.planning-data{\n\t\t\t\twidth: 50%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\t.header-planning{\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 18.77px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tmargin-top: 70px;\n\t\t\t\t\tmargin-left: 50px;\n\n\t\t\t\t}\n\t\t\t\timg{\n\t\t\t\t\twidth: 115%;\n\t\t\t\t\tfloat: right;\n\t\t\t\t}\n\n\t\t\t}\n\t\t\t\n\n\t    }\n\t    .right-content{\n\t    \twidth: 50%;\n\t    \tpadding: 120px 0px 80px 0px;\n\t    \tbox-shadow: -10px 5px 8px 0px #C4C4C466;\n\t    \t.card-content{\n\t    \t\theight: 144px;\n\t    \t\tpadding: 10px 50px;\n\n\t    \t\t.header{\n\t    \t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tline-height: 37.5px;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\tmargin-bottom: 10px;\n\t    \t\t}\n\t    \t\t.description{\n\t    \t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tfont-weight: 300;\n\t\t\t\t\tline-height: 19.05px;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\twidth: 40%;\n\t    \t\t}\n\t    \t}\n\t    \t.orange{\n\t    \t\tbackground: #EC6927;\n\t    \t}\n\t    \t.yellow{\n\t    \t\tbackground: #E7B051;\n\t    \t}\n\t    \t.purple{\n\t    \t\tbackground: #9DAAF1;\n\t    \t}\n\t    }\n\t}\n\n\t.PlatformSectionOne-card {\n\t\tpadding: 0 30px;\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\tz-index: 1;\n\t\tmargin-top: 60px;\n\t\t.box-card {\n\t\t\tpadding: 30px;\n\t\t\twidth: 230px;\n\t\t    height: 252px;\n\t\t    margin-right: 25px;\n\t\t    background: #FFFFFF;\n\t\t    box-shadow: 0px 4px 5px #C4C4C4;\n\t\t    border-radius: 3px;\n\t\t    border-top: 7px #EC6927 solid;\n\t\t    position: relative;\n\t\t    display: flex;\n\t\t    flex-direction: column;\n\t\t    cursor: pointer;\n\t\t    transition: all 0.3s ease 0s;\n\t\t    .card-description {\n\t\t    \tmargin-top: 20px;\n\t\t    \tfont-size: 16px;\n\t\t    \tline-height: 24px;\n\t\t    \tfont-weight: 300;\n\t\t    }\n\t\t}\n\t\t.box-card:hover {\n\t\t\ttransform: scale(1.05);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
